module.exports = __webpack_public_path__ + "static/media/alert.ddb89c23.svg";